import React from "react";
import Data from "./Data";
import "./Home.css";
import Slide from "./Slide";

const Home = () => {
  return (
    <>
      <Slide slides={Data} width="100px" height="300px" />
    </>
  );
};

export default Home;
